<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div v-if="item" class="md:col-8 sm:col-12 comp-grid">
              <div class="card nice-shadow-18">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-2xl text-primary font-bold">
                      {{ item.programme_title }}
                    </div>
                  </div>
                </div>
              </div>
              <Breadcrumb
                :home="{
                  icon: 'pi pi-arrow-left text-lg mr-3',
                  label: 'Back',
                  command: () => {
                    $router.go(-1);
                  },
                }"
                :model="[
                  {
                    label: 'Programmes',
                    to: '/institution_programmes',
                  },
                  {
                    label: item.programme_title,
                    to: '/institution_programmes/view/' + id,
                  },
                ]"
              />
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-8 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <div class="relative-position" style="min-height: 100px">
                  <template v-if="!loading && item">
                    <div class="row q-col-gutter-x-md">
                      <div class="col-12">
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Title:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_title }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Cut Off Point:
                            </div>
                            <div class="font-bold">
                              {{ item.cut_off_point }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Has Vacancy:
                            </div>
                            <div class="font-bold">{{ item.has_vacancy }}</div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Description:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_description }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Required Electives:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_required_electives }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Campuses:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_campuses }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Sessions:
                            </div>
                            <div class="font-bold">
                              {{ item.programme_sessions }}
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="grid align-items-center">
                          <div class="col">
                            <div class="text-500 text-sm mb-1">
                              Programme Options:
                            </div>
                            <div class="">
                              <div class="mt-4" v-if="item.programme_options">
                                <div
                                  v-for="(definition, index) in JSON.parse(
                                    item.programme_options
                                  )"
                                  :key="index"
                                >
                                  <div class="card">
                                    <div class="grid">
                                      <div class="col-2 text-primary font-bold">
                                        {{ "Option " + (index + 1) }}:
                                      </div>
                                      <div class="col">
                                        <div class="grid">
                                          <div class="col italic">
                                            Option Name:
                                          </div>
                                          <div class="col font-bold">
                                            {{ definition.option_name }}
                                          </div>
                                        </div>
                                        <hr />
                                        <div class="grid align-items-center">
                                          <div class="col italic">
                                            Required Electives:
                                          </div>
                                          <div class="col font-bold">
                                            {{
                                              definition.option_required_electives
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="flex justify-content-end">
                          <Menubar
                            class="p-0"
                            ref="actionMenu"
                            :model="getActionMenuModel(item)"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="sm:col-12 md:col-4">
            <div class="sticky-item"><file-svg-page></file-svg-page></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import fileSvgPage from "../custom/file_svg.vue";
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "viewInstitutionprogrammesPage",
  components: { fileSvgPage },
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_programmes",
    },
    idName: {
      type: String,
      default: "institution_programme_id",
    },
    routeName: {
      type: String,
      default: "institution_programmesview",
    },
    pagePath: {
      type: String,
      default: "institution_programmes/view",
    },
    apiPath: {
      type: String,
      default: "institution_programmes/view",
    },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Institution Programmes Details";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["institution_programmes/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("institution_programmes/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("institution_programmes", ["fetchRecord", "deleteRecord"]),
    getActionMenuModel(data) {
      return [
        {
          label: "Edit",
          to: `/institution_programmes/edit/${data.institution_programme_id}`,
          icon: "pi pi-pencil",
        },
        {
          label: "Delete",
          command: (event) => {
            this.deleteItem(data.institution_programme_id);
          },
          icon: "pi pi-minus-circle",
        },
      ];
    },
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
